import { FC } from 'react';
import classNames from 'classnames';
import { TickIcon } from 'Components';
import { Box } from '@material-ui/core';
import { useCreditCardType } from 'Hooks';
import { gutters } from 'Theme/Variables';
import { maskCreditCardNumber } from 'Utils';
import './PaymentMethodItem.scss';

type PaymentMethodItemProps = {
  hide: Function;
  isDialog: boolean;
  isSelected?: boolean;
  paymentMethodItem: any;
  onSelect?: (paymentMethod: any) => void;
};

const PaymentMethodItem: FC<PaymentMethodItemProps> = ({
  hide,
  isDialog,
  onSelect,
  paymentMethodItem,
  isSelected = false,
}) => {
  const { creditCardBrandUrl, creditCardLogoUrl } = useCreditCardType(paymentMethodItem);

  const handleSelect = () => {
    if (onSelect) {
      onSelect(paymentMethodItem);
    } else if (isDialog) {
      hide();
    }
  };

  return (
    <div
      id="paymentMethodItem"
      onClick={handleSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSelect(); } }}
    >
      <Box
        className={classNames({
          paymentMethodItem__container: true,
          'paymentMethodItem__container--active': isSelected,
        })}
      >
        <Box display="flex" alignItems="center">
          <Box marginRight={gutters.regular} width={66}>
            <img src={creditCardLogoUrl} alt="" className="paymentMethodItem--cardLogo" />
          </Box>
          <Box display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column" flex={1}>
            {paymentMethodItem?.cardAlias && <Box className="paymentMethodItem--title">{paymentMethodItem?.cardAlias}</Box>}
            {paymentMethodItem?.maskedCardNumber && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Box className="paymentMethodItem--cardNumber">{maskCreditCardNumber(paymentMethodItem?.maskedCardNumber)}</Box>
                <span className="paymentMethodItem--dot" />
                <img className="paymentMethodItem--brand" src={creditCardBrandUrl} alt="" />
              </Box>
            )}
          </Box>
        </Box>
        {isDialog && isSelected && <TickIcon />}
      </Box>
    </div>
  );
};

export default PaymentMethodItem;
export { PaymentMethodItem };
